/**
 * @expFlag 3promo-enabled-public-animated-trend-modal
 * @ticket CLOUDWEB-20130
 * @file
 */
/* eslint-disable max-lines-per-function */
import { Button, ButtonGroup, Subhead, Title } from '@vkontakte/vkui';
import classNames from 'clsx';
import React, { memo } from 'react';
import styles from 'reactApp/components/PublicAnimatedTrendModal/PublicAnimatedTrendModal.css';
import { Screen } from 'reactApp/ui/Screen/Screen';

export interface IPublicAnimatedTrendFullscreenProps {
    theme: 'blue' | 'light-blue';
    title: string;
    subtitle: string;
    buttons: Array<{
        onClick?(): void;
        appearance: 'accent' | 'neutral' | 'overlay';
        text: string;
        href?: string;
        qaId?: string;
    }>;
    onClose(): void;
    onXCloseAnalytics(): void;
    handleButtonClick(button: { onClick?(): void }): void;
    closable: boolean;
    imageSrc: string;
}

export const PublicAnimatedTrendFullscreen = memo<IPublicAnimatedTrendFullscreenProps>(
    ({ theme, title, subtitle, buttons, onXCloseAnalytics, closable, imageSrc, handleButtonClick, onClose }) => {
        const isBlueTheme = theme === 'blue';

        return (
            <Screen
                onClose={() => {
                    onXCloseAnalytics();
                    onClose();
                }}
                closable={closable}
                withLogo={false}
                aboveAll={false}
                className={classNames({
                    [styles.screen]: true,
                    [styles.light_screen]: !isBlueTheme,
                })}
                closeIconClassName={styles.closeIcon}
                contentClassName={styles.screen_content}
            >
                <div className={styles.rootMobileScreen}>
                    <div className={styles.imageContainerFullscreen}>
                        <img src={imageSrc} className={styles.image} />
                    </div>
                    <div className={styles.textBox}>
                        <Title
                            level="1"
                            className={classNames({
                                [styles.fullscreenTitle]: true,
                                [styles.title_color]: isBlueTheme,
                            })}
                            data-qa-id="public-benefits-auth-mob-header"
                        >
                            {title}
                        </Title>
                        <Subhead
                            weight="3"
                            className={classNames({
                                [styles.fullscreenSubhead]: true,
                                [styles.subhead_color]: isBlueTheme,
                            })}
                            data-qa-id="public-benefits-auth-mob-content"
                        >
                            {subtitle}
                        </Subhead>
                    </div>
                    <ButtonGroup mode="vertical" gap="m" stretched className={styles.screenButtonGroup}>
                        {buttons.map((button, index) => (
                            <Button
                                key={index}
                                size="l"
                                mode="primary"
                                appearance={button.appearance}
                                onClick={() => handleButtonClick(button)}
                                stretched
                                Component={button.href ? 'a' : 'button'}
                                href={`${button.href}?mt_deeplink=${window.location.href}`}
                                className={classNames({
                                    [styles.button_accent_black_color]: button.appearance === 'accent' && isBlueTheme,
                                })}
                                data-qa-id={button.qaId}
                            >
                                {button.text}
                            </Button>
                        ))}
                    </ButtonGroup>
                </div>
            </Screen>
        );
    }
);

PublicAnimatedTrendFullscreen.displayName = 'PublicAnimatedTrendFullscreen';
